import React, {useState} from 'react'

const PasswordField = ({
                                   label = 'Password',
                                   required = true,
                                   value,
                                   onChange,
                                   placeholder = '',
                                   name = 'password',
                                   showVisibilityToggle = false
                               }) => {
    const [isPasswordVisible, setIsPasswordVisible] = useState(false)
    const inputType = showVisibilityToggle && isPasswordVisible ? "text" : "password"
    const toggleLabel = isPasswordVisible ? "Verberg wachtwoord" : "Toon wachtwoord"

    return (
        <div className="kav-input-field">
            <label className="kav-input-field__label" htmlFor={name}>
                {label}
                {required && <span className="kav-input-field__required">*</span>}
            </label>
            <div className="kav-password-field">
                <input
                    id={name}
                    name={name}
                    type={inputType}
                    className={`kav-input-field__input ${showVisibilityToggle ? "kav-input-field__input--withToggle" : ""}`}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    required={required}
                />
                {showVisibilityToggle && (
                    <button
                        type="button"
                        className="kav-password-field__toggle"
                        onClick={() => setIsPasswordVisible((prev) => !prev)}
                        aria-label={toggleLabel}
                        aria-pressed={isPasswordVisible}
                    >
                        <i className={`bi ${isPasswordVisible ? "bi-eye-slash" : "bi-eye"}`} aria-hidden="true"></i>
                    </button>
                )}
            </div>
        </div>
    )
}

export default PasswordField
